/* istanbul ignore file */
import { FC } from 'react';
import {
  IconSafetyDistancing,
  IconSafetyProtecting,
  IconSafetySanitizing,
  IconSafetyScreening,
} from '@tock/icons';

export const IconDistancingSmall: FC = () => <IconSafetyDistancing fontSize="small" />;

export const IconDistancingMedium: FC = () => <IconSafetyDistancing fontSize="medium" />;

export const IconDistancingLarge: FC = () => <IconSafetyDistancing fontSize="large" />;

export const IconProtectingSmall: FC = () => <IconSafetyProtecting fontSize="small" />;

export const IconProtectingMedium: FC = () => <IconSafetyProtecting fontSize="medium" />;

export const IconProtectingLarge: FC = () => <IconSafetyProtecting fontSize="large" />;

export const IconSanitizingSmall: FC = () => <IconSafetySanitizing fontSize="small" />;

export const IconSanitizingMedium: FC = () => <IconSafetySanitizing fontSize="medium" />;

export const IconSanitizingLarge: FC = () => <IconSafetySanitizing fontSize="large" />;

export const IconScreeningSmall: FC = () => <IconSafetyScreening fontSize="small" />;

export const IconScreeningMedium: FC = () => <IconSafetyScreening fontSize="medium" />;

export const IconScreeningLarge: FC = () => <IconSafetyScreening fontSize="large" />;
